// WILD RUSH plate + effect hotspots (percent of viewport). Plates live in /public/wildrush and were produced
// from the approved WILD_RUSH_Visual_Master (hero crop adapted for "title"; stage plates extended from its storyboard panels).
export const ENVS = ["title", "forest", "fork", "river", "rocks", "ridge", "checkpoint"];

export const plateUrl = (env, aspect, lq = false) => `/wildrush/${env}-${aspect}${lq ? "-lq" : ""}.webp`;

export const PLATE_ASPECT = { wide: 16 / 9, tall: 9 / 16 };

// All coordinates are percentages of the PLATE image (mapped to the viewport at render time, since plates render with cover).
// beacon: distant checkpoint beam [x,y]; crystal: near beacon [x,y]; mist: [x,y,size]; water: shimmer box [x,y,w,h]; sun: light source [x,y]
export const FX = {
  title:      { wide: { beacon: [57, 14], mist: [[39, 45, 14], [52, 78, 12]], water: [[40, 66, 24, 28]] },
                tall: { beacon: [60, 28], mist: [[33, 40, 12], [48, 56, 10]], water: [[30, 50, 40, 16]] } },
  forest:     { wide: { sun: [14, 0] },  tall: { sun: [84, 0] } },
  fork:       { wide: { sun: [50, 0] },  tall: { sun: [40, 0] } },
  river:      { wide: { mist: [[38, 46, 10]], water: [[30, 55, 70, 45]] },
                tall: { mist: [[36, 40, 10]], water: [[0, 44, 100, 18]] } },
  rocks:      { wide: { mist: [[78, 88, 14]], water: [[58, 70, 42, 30]] },
                tall: { mist: [[82, 64, 10]], water: [[66, 58, 34, 16]] } },
  ridge:      { wide: { beacon: [54, 12] }, tall: { beacon: [34, 28] } },
  checkpoint: { wide: { crystal: [51, 32] }, tall: { crystal: [51, 43] } },
};

// Foreground parallax cutouts (same world, chroma-keyed): bough = top-left, ferns = bottom-left, rock = bottom-right
export const FOREGROUND = {
  title:      ["bough", "ferns"],
  forest:     ["bough", "ferns"],
  fork:       ["ferns", "rock"],
  river:      ["bough", "rock"],
  rocks:      ["ferns"],
  ridge:      ["rock"],
  checkpoint: ["ferns", "rock"],
};

// Fictional WILD RUSH player avatars (one coherent stylised 3D set, sliced from a single render; no real people, age-neutral).
export const AVATAR_FILES = { Sam17: "sam17", Kai_09: "kai_09", "mira.plays": "mira_plays", Tobs: "tobs", ridge_runner17: "ridge_runner17", visor: "gallery_1", fox: "gallery_2", bolt: "gallery_3", orbit: "gallery_4" };
export const avatarUrl = (key) => `/wildrush/avatars/${AVATAR_FILES[key] || "sam17"}.webp`;
